import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=3faa5e4a"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"
import style0 from "./Sku.vue?vue&type=style&index=0&id=3faa5e4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports